<mat-card appearance="outlined" class="mat-card-angle" [class.frameless]="frameless">
  <mat-card-content>
    <div class="orientation-layer" #orientationLayer>
      <canvas #orientationCanvas class="orientation-canvas"></canvas>
    </div>
    @if (chartsReady && hasChartOption) {
      <div class="scatter-layer base-layer">
        <div echarts [options]="chartOption" class="scatter-chart" (chartInit)="onBaseChartInit($event)"></div>
      </div>
      <div class="scatter-layer overlay-layer">
        <div echarts [options]="currentChartOption" class="scatter-chart" (chartInit)="onCurrentChartInit($event)"></div>
      </div>
    }
    @if (chartsReady && !hasChartOption) {
      <div class="no-data-placeholder">{{ noDataLabel }}</div>
    }
    <div class="angle-hint">{{ angleInfoLabel }}</div>
  </mat-card-content>
</mat-card>
